package structs.accelbyte.promo

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import structs.accelbyte.common.AccelByteSerializable

/**
 * Outcome type operator attaches to a promo code batch.
 *
 * AGS `platform campaigns` grant items, not wallet credit or subscriptions directly;
 * the mapping from a granted item to operator-side effects (subscription months,
 * wallet credit) is wired downstream of this enum by the operator. See
 * `.hermes/plans/2026-08-20_promo-codes-ags-campaigns.md` for the split.
 *
 * @property SUBSCRIPTION_MONTHS AGS campaign whose `RedeemableItem` references a
 *   tier subscription item with `extraSubscriptionDays` set to N*30 days.
 * @property CREDITS_GRANT AGS campaign whose `RedeemableItem` references a
 *   credit-bundle item whose grant type increments the player's wallet.
 */
@Serializable
enum class PromoOutcomeType {
    @SerialName("SUBSCRIPTION_MONTHS")
    SUBSCRIPTION_MONTHS,

    @SerialName("CREDITS_GRANT")
    CREDITS_GRANT,
}
